import {backend, fetchBase, Geo} from '../lib/backend';
import {ColumnDef, Report} from '../lib/types';
import {mapObjectOntoTableauStruct} from '../lib/utils';

const columns: ColumnDef[] = [
    {
        name: "equipment_id",
        type: tableau.dataTypeEnum.string,
        alias: "Machine ID",
        description: "Machine unique identifier"
    },
    {
        name: "equipment",
        type: tableau.dataTypeEnum.string,
        alias: "Machine",
        description: "Machine model and number plate"
    },
    {
        name: "runTime",
        type: tableau.dataTypeEnum.string,
        alias: "Runtime",
        description: "Machine runtime"
    },
    {
        name: "stopTime",
        type: tableau.dataTypeEnum.string,
        alias: "Stop time",
        description: "Machine stop time"
    },
    {
        name: "utilization_10h",
        type: tableau.dataTypeEnum.string,
        alias: "Utilization_10",
        description: "Utilization in (10 Hours)"
    },
    {
        name: "utilization_24h",
        type: tableau.dataTypeEnum.string,
        alias: "Utilization_24",
        description: "Utilization in (24 Hours)"
    },
    {
        name: "subcontractors",
        type: tableau.dataTypeEnum.string,
        alias: "Subcontractors",
        description: "Subcontractors"
    },
    {
        name: "no_of_days",
        type: tableau.dataTypeEnum.int,
        alias: "No of Days",
        description: "No of days active"
    },
    {
        name: "last_ping",
        type: tableau.dataTypeEnum.datetime,
        alias: "Last ping date",
        description: "Last ping date"
    }
];

const getReport = async () => {

    const connectionData_1 = tableau.connectionData ? JSON.parse(tableau.connectionData) : {};
    const geo = (connectionData_1.geo || "uae") as Geo;
    const account = (connectionData_1.account || "");

    const url = `/app/reports/sync?report_type=json`;

    let equipments = await backend.getEquipmentsByAccount({
        accountId: account,
        limit: 500,
    }, tableau.password, geo);

    let body = {
        "equipmentIds": equipments.map(a => a.id),
        "startDate": new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7)).toString(),
        "endDate": new Date().toString(),
        "reportType": "WorktimeSummary",
        "formatType": "json",
        "projectId": "",
        "summary": false
    }
    var myHeaders = { "Content-Type": "application/json" };

    const options: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(body)
    };

    let res = await fetchBase(url, options, tableau.password, geo);
    return mapObjectOntoTableauStruct(res, columns);
}

export const worktime_summary_report: Report = {
    id: 'worktimeSummaryReport7Days',
    alias: 'Worktime Summary Report (7 Days)',
    columns,
    get: getReport,

};
